<input type="text" value="" class="heightzero" #clipboardInput>
<div class="tabcontainer">
  <div class="searchBlock">
    <div class="searchSection">
      <i class="icon-search"></i>
      <div class="searchtxt">
        <input #listingInput id="searchInputBox"class="search-components textBox" type="text" [placeholder]="placeholder" [(ngModel)]="str"
          (keydown)="onKeydown($event, listingInput)" (focus)="searchFocus = true" (focusout)="searchFocus = false"
          autofocus />
          <ng-container *ngIf="listSuggestionArray && listSuggestionArray.length > 0">
            <div [ngClass]="(showSuggestionBox) ? 'block' : '' " class="autosuggestion" *ngIf="listSuggestionArray">
              <ul>
                <ng-container *ngFor="let item of listSuggestionArray; let i = index ; trackBy: trackByName; ">
                  <li [class.active]="i == arrowkeyLocation">
                    <span class="name" (click)="getsearchResults(item)">{{item}}</span>
                  </li>
                </ng-container>
              </ul>
            </div>
          </ng-container>
      </div>
    </div>
    <div class="filterSection spImg">
      <i class="icon-filter"></i>
      <div class="fliterBlock">
        <div class="searchfilter">
          <span [class]="exactMatch ? 'exact green' : 'exact'" (click)="toggleSwitch('exact')" tabindex="0"
            (keydown)="callToggles($event, 'exact')" id="searchFilter">
            Exact & Latest
          </span>
        </div>
        <ul class="filterOption">
          <ng-container *ngIf="filterList && facets">
            <ng-container *ngFor="let filter of filterList;let i = index">
              <li [class]="(i <= 3) ? 'togfilt block abc' : (i > 3 && showMore) ? 'togfilt block abc' : 'togfilt none'">
                <filter [filterType]="filter.type" [displayName]="filter.name"
                  [data]="getFilterData(filter.facet_name_meta)" [facetName]="filter.facet_name"
                  [facetNameMeta]="filter.facet_name_meta" [isDataKeyValuePair]="filter.isDataKeyValuePair"
                  [filterId]="filter.filter_id" (filterSelect)="urlUpdate($event)"></filter>
              </li>
              <span #moreButtonEl tabindex="0"
                [class]="(checkFocusInside(moreButtonEl) ? (showMore ? 'morefilterdrop spImg less focused' : 'morefilterdrop spImg more focused') : (showMore ? 'morefilterdrop spImg less' : 'morefilterdrop spImg more'))"
                (click)="(showMore = !showMore)"
                *ngIf="(filterList && filterList.length > 4 ) && i === 3">{{(showMore) ? 'less' : 'more'}}</span>
            </ng-container>
          </ng-container>
        </ul>
      </div>
    </div>
    <div class="closebg"></div>
  </div>

  <div class="storyMobScroll ">
  <div class="headingsList widthCustom">
    <ul>
      <ng-container *ngFor="let header of headerList">
        <li [class]="header.class">{{header.name}}</li>
      </ng-container>
    </ul>
  </div>
  <div class="contentList widthCustom">
    <ng-template #loading>
      <div style="text-align: center; display: inline-block; width: 100%;">
        <ng-container *ngIf="callFail">
          <div style="text-align: center; display: inline-block; width: 100%; padding-top:200px;">
            Sorry, Server Error
          </div>
        </ng-container>
        <ng-container *ngIf="!callFail">
          <div class="imagepreloader">
            <div class="a" style="--n: 5;">
              <div class="dot dot1" style="--i: 0;"></div>
              <div class="dot dot2" style="--i: 1;"></div>
              <div class="dot dot3" style="--i: 2;"></div>
              <div class="dot dot4" style="--i: 3;"></div>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-template>

    <ng-template #nores>
      <div style="text-align: center; display: inline-block; width: 100%; padding-top:200px;">No Data</div>
    </ng-template>
    <ng-container *ngIf="noresults == false;then listData else nores"></ng-container>
    <ng-template #listData>
      <ng-container *ngIf="listArray && listArray.length > 0;else loading">
        <ng-container [ngSwitch]="pageId">
          <ng-container *ngSwitchCase="'agencyFeed'">
            <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">
              <ul #listEl tabindex="0" class="locked rssfeedul" #listData2>

                <li (click)="openPreview(item)" id="headlineColumn" class="headline" [title]="item.headline">
                  <div class="relhidden">
                    <div class="listCell">{{item.headline}}</div>
                  </div>
                </li>

                <li (click)="openPreview(item)" id="agencyColumnFeedList" class="agency" [title]="item.agency">
                  <div class="relhidden">
                    <div class="listCell">{{item.agency}}</div>
                  </div>
                </li>

                <li (click)="openPreview(item)" id="sectionColumnFeedList" class="section" [title]="item.section">
                  <div class="relhidden">
                    <div class="listCell">{{item.section}}</div>
                  </div>
                </li>

                <li (click)="openPreview(item)" id="receivedAtList" class="receivedAt">
                  <div class="relhidden">
                    <div class="listCell">{{getNewTypeDate(item.timestamp)}}</div>
                  </div>
                </li>

                <li class="pickUp">
                  <span class="pickStory icon-pickup" (click)="openStoryEdit(item)">
                    <div id="pickUpList" class="arrow_box single">Pick as Story</div>
                  </span>
                  <span [class]="(checkIfOnePublished(item) ? 'pickLink green icon-link' : 'pickLink icon-link')"
                    *ngIf="item.wirePublishedStories && item.wirePublishedStories.length > 0 && checkDomain(item)">
                    <!-- {{item ? item.agency : 'temporary'}} -->
                    <ng-container *ngIf="item.wirePublishedStories.length > 1">
                      <div class="arrow_box multiple">
                        <ng-container *ngFor="let pickedStory of item.wirePublishedStories">
                          <ng-container *ngIf="pickedStory">
                            <ul>
                              <li (click)="open_new(pickedStory.id)" *ngIf="pickedStory.domainId == domain">
                                <div
                                  [class]="((pickedStory.metadata && pickedStory.metadata.status
                                  && pickedStory.metadata.status === 'PUBLISHED') ? 'storyline published' : 'storyline')">
                                  {{pickedStory.title ? pickedStory.title : ''}}</div>
                                <div class="writername">
                                  {{(pickedStory.metadata != null && pickedStory.metadata.authors != null
                                    && pickedStory.metadata.authors.length > 0) ? pickedStory.metadata.authors[0] : '-'}}
                                </div>
                              </li>
                            </ul>
                          </ng-container>
                        </ng-container>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="item.wirePublishedStories && item.wirePublishedStories.length === 1">
                      <div class="arrow_box single" *ngIf="item.wirePublishedStories[0].domainId == domain">
                        {{item.wirePublishedStories[0].title ? item.wirePublishedStories[0].title : ''}}
                      </div>
                    </ng-container>
                  </span>
                  <!-- <span> <i class="pickLink icomoon icon-broken-link"></i></span> -->
               
                </li>

              </ul>
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="'twitterFeed'">
            <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">
              <ul #listEl tabindex="0" class="locked rssfeedul" #listData2>

                <li (click)="openTwitterPreview(item)" id="headlineColumn" class="twitter-message" [title]="item.headline">
                  <div class="relhidden">
                    <div class="listCell">{{item.twitterMessage}}</div>
                  </div>
                </li>

                <li (click)="openTwitterPreview(item)" id="agencyColumnFeedList" class="twitter-handle" [title]="item.agency">
                  <div class="relhidden">
                    <div class="listCell">{{item.twitterHandle}}</div>
                  </div>
                </li>


                <li (click)="openTwitterPreview(item)" id="receivedAtList" class="twitter-created-date">
                  <div class="relhidden">
                    <div class="listCell">{{getNewTypeDate(item.createdDate)}}</div>
                  </div>
                </li>

                <li class="pickUp">
                  <span class="pickStory icon-cards" (click)="copyFunction(item.embeddedCode)">
                    <div id="pickUpList" class="arrow_box single">Copy URL</div>
                  </span>  
                </li>

              </ul>
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="'hindiFeed'">
            <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">
              <ul #listEl tabindex="0" class="locked rssfeedul" #listData2>

                <li (click)="openPreview(item)" class="headline" [title]="item.headline">
                  <div class="relhidden">
                    <div class="listCell">{{item.headline}}</div>
                  </div>
                </li>

                <li (click)="openPreview(item)" class="agency" [title]="item.agency">
                  <div class="relhidden">
                    <div class="listCell">{{item.agency}}</div>
                  </div>
                </li>

                <li (click)="openPreview(item)" class="section" [title]="item.section">
                  <div class="relhidden">
                    <div class="listCell">{{item.section}}</div>
                  </div>
                </li>

                <li (click)="openPreview(item)" class="receivedAt">
                  <div class="relhidden">
                    <div class="listCell">{{getNewTypeDate(item.timestamp)}}</div>
                  </div>
                </li>

                <li class="pickUp">
                  <span class="pickStory icon-pickup" (click)="openStoryEdit(item)">
                    <div class="arrow_box single">Pick as Story</div>
                  </span>
                  <span [class]="(checkIfOnePublished(item) ? 'pickLink green icon-link' : 'pickLink icon-link')"
                    *ngIf="item.wirePublishedStories && item.wirePublishedStories.length > 0 && checkDomain(item)">
                    <!-- {{item ? item.agency : 'temporary'}} -->
                    <ng-container *ngIf="item.wirePublishedStories.length > 1">
                      <div class="arrow_box multiple">
                        <ng-container *ngFor="let pickedStory of item.wirePublishedStories">
                          <ng-container *ngIf="pickedStory">
                            <ul>
                              <li (click)="open_new(pickedStory.id)" *ngIf="pickedStory.domainId == domain">
                                <div
                                  [class]="((pickedStory.metadata && pickedStory.metadata.status
                                  && pickedStory.metadata.status === 'PUBLISHED') ? 'storyline published' : 'storyline')">
                                  {{pickedStory.title ? pickedStory.title : ''}}</div>
                                <div class="writername">
                                  {{(pickedStory.metadata != null && pickedStory.metadata.authors != null
                                    && pickedStory.metadata.authors.length > 0) ? pickedStory.metadata.authors[0] : '-'}}
                                </div>
                              </li>
                            </ul>
                          </ng-container>
                        </ng-container>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="item.wirePublishedStories && item.wirePublishedStories.length === 1">
                      <div class="arrow_box single" *ngIf="item.wirePublishedStories[0].domainId == domain">
                        {{item.wirePublishedStories[0].title ? item.wirePublishedStories[0].title : ''}}
                      </div>
                    </ng-container>
                  </span>
                  <!-- <span> <i class="pickLink icomoon icon-broken-link"></i></span> -->
                </li>

              </ul>
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="'printFeed'">
            <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">
              <ul #listEl tabindex="0" class="locked rssfeedul" #listData2>

                <li (click)="openPreview(item)" class="headline" [title]="item.headline">
                  <div class="relhidden">
                    <div class="listCell" [innerHTML]="item.headline"></div>
                  </div>
                </li>

                <li (click)="openPreview(item)" class="agency" *ngIf="!printFeedForLH">
                  <div class="relhidden">
                    <div class="listCell">{{getNewTypeDateDay(item.issueDate)}}</div>
                  </div>
                </li>

                <li (click)="openPreview(item)" class="section" [title]="item.section" *ngIf="!printFeedForLH">
                  <div class="relhidden">
                    <div class="listCell">{{item.section}}</div>
                  </div>
                </li>

                <li (click)="openPreview(item)" class="status" [title]="item.status" *ngIf="!domainWiseAgency">
                  <div class="relhidden">
                    <div class="listCell">{{item.status}}</div>
                  </div>
                </li>

                <li (click)="openPreview(item)" [ngClass]="printFeedForLH ? 'receivedAt_LH_print' : 'receivedAt' " >
                  <div class="relhidden">
                    <div class="listCell">{{getNewTypeDate(item.timestamp)}}</div>
                  </div>
                </li>

                <li class="pickUp">
                  <span class="pickStory icon-pickup" (click)="openStoryEdit(item)">
                    <div id="pickUpList" class="arrow_box single">Pick as Story</div>
                  </span>
                  <span [class]="(checkIfOnePublished(item) ? 'pickLink green icon-link' : 'pickLink icon-link')"
                    *ngIf="item.wirePublishedStories && item.wirePublishedStories.length > 0 && (!item.autoPublishError || item.autoPublishError.length === 0) && checkDomain(item)">
                    <!-- {{item ? item.agency : 'temporary'}} -->
                    <ng-container *ngIf="item.wirePublishedStories && item.wirePublishedStories.length > 1">
                      <div class="arrow_box multiple">
                        <ng-container *ngFor="let pickedStory of item.wirePublishedStories">
                          <ng-container *ngIf="pickedStory">
                            <ul>
                              <li (click)="open_new(pickedStory.id)" *ngIf="pickedStory.domainId == domain">
                                <div
                                  [class]="((pickedStory.metadata && pickedStory.metadata.status
                                && pickedStory.metadata.status === 'PUBLISHED') ? 'storyline published' : 'storyline')">
                                  {{pickedStory.title ? pickedStory.title : ''}}</div>
                                <div class="writername">
                                  {{(pickedStory.metadata != null && pickedStory.metadata.authors != null
                                  && pickedStory.metadata.authors.length > 0) ? pickedStory.metadata.authors[0] : '-'}}
                                </div>
                              </li>
                            </ul>
                          </ng-container>
                        </ng-container>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="item.wirePublishedStories && item.wirePublishedStories.length === 1">
                      <div class="arrow_box single" *ngIf="item.wirePublishedStories[0].domainId == domain">
                        {{item.wirePublishedStories[0].title ? item.wirePublishedStories[0].title : ''}}
                      </div>
                    </ng-container>
                  </span>

                  <span class="pickLink red icon-link"
                    *ngIf="item.autoPublishError && item.autoPublishError.length > 0">
                    <ng-container *ngIf="item.autoPublishError && item.autoPublishError.length > 0">
                      <div class="arrow_box single">
                        <ng-container *ngFor="let error of item.autoPublishError">
                          {{error}}&nbsp;
                        </ng-container>
                      </div>
                    </ng-container>
                  </span>
                  
                  <span (click)="navigateToFrontendStory(item.wirePublishedStories[0])" *ngIf="item && item.wirePublishedStories && item.wirePublishedStories.length == 1 && !item.autoPublishError"> 
                    <i class="pickLink icomoon icon-broken-link"></i>
                  </span>

                  <span *ngIf="item && item.wirePublishedStories && item.wirePublishedStories.length > 1 && !item.autoPublishError" class="pickLink icon-broken-link">
                    <i class="related_icon spImg_story">
                      <img  alt="View Story" src="assets/images/link-out.png" width="14px" height="14px">
                    </i>
                    <div class="arrow_box multiple">
                      <ul *ngFor="let pickedStory of item.wirePublishedStories">
                        <li (click)="navigateToFrontendStory(pickedStory)">
                            <div class="storyline">
                              {{pickedStory.title ? pickedStory.title : ''}}
                            </div>
                        </li>
                      </ul>
                    </div>
                  </span>
                </li>

              </ul>
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="'currentEconomistFeed'">
            <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">
              <ul #listEl tabindex="0" class="locked rssfeedul" #listData2>

                <li (click)="openPreview(item)" class="headline" [title]="item.headline">
                  <div class="relhidden">
                    <div class="listCell" [innerHTML]="item.headline"></div>
                  </div>
                </li>

                <li (click)="openPreview(item)" class="agency">
                  <div class="relhidden">
                    <div class="listCell">{{getNewTypeDateYear(item.issueDate)}}</div>
                  </div>
                </li>

                <li (click)="openPreview(item)" class="section" [title]="item.section">
                  <div class="relhidden">
                    <div class="listCell">{{item.section}}</div>
                  </div>
                </li>

                <li (click)="openPreview(item)" class="status" [title]="item.status">
                  <div class="relhidden">
                    <div class="listCell">{{item.status}}</div>
                  </div>
                </li>

                <li (click)="openPreview(item)" class="receivedAt">
                  <div class="relhidden">
                    <div class="listCell">{{getNewTypeDate(item.timestamp)}}</div>
                  </div>
                </li>

                <li class="pickUp">
                  <span class="pickStory icon-pickup" (click)="openStoryEdit(item)">
                    <div class="arrow_box single">Pick as Story</div>
                  </span>
                  <span [class]="(checkIfOnePublished(item) ? 'pickLink green icon-link' : 'pickLink icon-link')"
                    *ngIf="item.wirePublishedStories && item.wirePublishedStories.length > 0">
                    <!-- {{item ? item.agency : 'temporary'}} -->
                    <ng-container *ngIf="item.wirePublishedStories && item.wirePublishedStories.length > 1">
                      <div class="arrow_box multiple">
                        <ng-container *ngFor="let pickedStory of item.wirePublishedStories">
                          <ng-container *ngIf="pickedStory">
                            <ul>
                              <li (click)="open_new(pickedStory.id)" *ngIf="pickedStory.domainId == domain">
                                <div
                                  [class]="((pickedStory.metadata && pickedStory.metadata.status
                                  && pickedStory.metadata.status === 'PUBLISHED') ? 'storyline published' : 'storyline')">
                                  {{pickedStory.title ? pickedStory.title : ''}}</div>
                                <div class="writername">
                                  {{(pickedStory.metadata != null && pickedStory.metadata.authors != null
                                    && pickedStory.metadata.authors.length > 0) ? pickedStory.metadata.authors[0] : '-'}}
                                </div>
                              </li>
                            </ul>
                          </ng-container>
                        </ng-container>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="item.wirePublishedStories && item.wirePublishedStories.length === 1">
                      <div class="arrow_box single" *ngIf="item.wirePublishedStories[0].domainId == domain">
                        {{item.wirePublishedStories[0].title ? item.wirePublishedStories[0].title : ''}}
                      </div>
                    </ng-container>
                  </span>
                  <!-- <span> <i class="pickLink icomoon icon-broken-link"></i></span> -->
                </li>


              </ul>
            </ng-container>
          </ng-container>

          
          <ng-container *ngSwitchCase="'archivedEconomistFeed'">
            <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">
              <ul #listEl tabindex="0" class="locked rssfeedul" #listData2>

                <li (click)="openPreview(item)" class="headline" [title]="item.headline">
                  <div class="relhidden">
                    <div class="listCell" [innerHTML]="item.headline"></div>
                  </div>
                </li>

                <li (click)="openPreview(item)" class="agency">
                  <div class="relhidden">
                    <div class="listCell">{{getNewTypeDateYear(item.issueDate)}}</div>
                  </div>
                </li>

                <li (click)="openPreview(item)" class="section" [title]="item.section">
                  <div class="relhidden">
                    <div class="listCell">{{item.section}}</div>
                  </div>
                </li>

                <li (click)="openPreview(item)" class="status" [title]="item.status">
                  <div class="relhidden">
                    <div class="listCell">{{item.status}}</div>
                  </div>
                </li>

                <li (click)="openPreview(item)" class="receivedAt">
                  <div class="relhidden">
                    <div class="listCell">{{getNewTypeDate(item.timestamp)}}</div>
                  </div>
                </li>

                <li class="pickUp">
                  <span class="pickStory icon-pickup" (click)="openStoryEdit(item)">
                    <div class="arrow_box single">Pick as Story</div>
                  </span>
                  <span [class]="(checkIfOnePublished(item) ? 'pickLink green icon-link' : 'pickLink icon-link')"
                    *ngIf="item.wirePublishedStories && item.wirePublishedStories.length > 0">
                    <!-- {{item ? item.agency : 'temporary'}} -->
                    <ng-container *ngIf="item.wirePublishedStories && item.wirePublishedStories.length > 1">
                      <div class="arrow_box multiple">
                        <ng-container *ngFor="let pickedStory of item.wirePublishedStories">
                          <ng-container *ngIf="pickedStory">
                            <ul>
                              <li (click)="open_new(pickedStory.id)" *ngIf="pickedStory.domainId == domain">
                                <div
                                  [class]="((pickedStory.metadata && pickedStory.metadata.status
                                  && pickedStory.metadata.status === 'PUBLISHED') ? 'storyline published' : 'storyline')">
                                  {{pickedStory.title ? pickedStory.title : ''}}</div>
                                <div class="writername">
                                  {{(pickedStory.metadata != null && pickedStory.metadata.authors != null
                                    && pickedStory.metadata.authors.length > 0) ? pickedStory.metadata.authors[0] : '-'}}
                                </div>
                              </li>
                            </ul>
                          </ng-container>
                        </ng-container>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="item.wirePublishedStories && item.wirePublishedStories.length === 1">
                      <div class="arrow_box single" *ngIf="item.wirePublishedStories[0].domainId == domain">
                        {{item.wirePublishedStories[0].title ? item.wirePublishedStories[0].title : ''}}
                      </div>
                    </ng-container>
                  </span>
                  <!-- <span> <i class="pickLink icomoon icon-broken-link"></i></span> -->
                </li>


              </ul>
            </ng-container>
          </ng-container>

          <ng-container *ngSwitchCase="'printEconomistFeed'">
            <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">
              <ul #listEl tabindex="0" class="locked rssfeedul" #listData2>

                <li (click)="openPreview(item)" class="headline" [title]="item.headline">
                  <div class="relhidden">
                    <div class="listCell" [innerHTML]="item.headline"></div>
                  </div>
                </li>

                <li (click)="openPreview(item)" class="agency">
                  <div class="relhidden">
                    <div class="listCell">{{getNewTypeDateYear(item.issueDate)}}</div>
                  </div>
                </li>

                <li (click)="openPreview(item)" class="section" [title]="item.section">
                  <div class="relhidden">
                    <div class="listCell">{{item.section}}</div>
                  </div>
                </li>

                <li (click)="openPreview(item)" class="status" [title]="item.status">
                  <div class="relhidden">
                    <div class="listCell">{{item.status}}</div>
                  </div>
                </li>

                <li (click)="openPreview(item)" class="receivedAt">
                  <div class="relhidden">
                    <div class="listCell">{{getNewTypeDate(item.timestamp)}}</div>
                  </div>
                </li>

                <li class="pickUp">
                  <span class="pickStory icon-pickup" (click)="openStoryEdit(item)">
                    <div class="arrow_box single">Pick as Story</div>
                  </span>
                  <span [class]="(checkIfOnePublished(item) ? 'pickLink green icon-link' : 'pickLink icon-link')"
                    *ngIf="item.wirePublishedStories && item.wirePublishedStories.length > 0">
                    <!-- {{item ? item.agency : 'temporary'}} -->
                    <ng-container *ngIf="item.wirePublishedStories && item.wirePublishedStories.length > 1">
                      <div class="arrow_box multiple">
                        <ng-container *ngFor="let pickedStory of item.wirePublishedStories">
                          <ng-container *ngIf="pickedStory">
                            <ul>
                              <li (click)="open_new(pickedStory.id)" *ngIf="pickedStory.domainId == domain">
                                <div
                                  [class]="((pickedStory.metadata && pickedStory.metadata.status
                                  && pickedStory.metadata.status === 'PUBLISHED') ? 'storyline published' : 'storyline')">
                                  {{pickedStory.title ? pickedStory.title : ''}}</div>
                                <div class="writername">
                                  {{(pickedStory.metadata != null && pickedStory.metadata.authors != null
                                    && pickedStory.metadata.authors.length > 0) ? pickedStory.metadata.authors[0] : '-'}}
                                </div>
                              </li>
                            </ul>
                          </ng-container>
                        </ng-container>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="item.wirePublishedStories && item.wirePublishedStories.length === 1">
                      <div class="arrow_box single" *ngIf="item.wirePublishedStories[0].domainId == domain">
                        {{item.wirePublishedStories[0].title ? item.wirePublishedStories[0].title : ''}}
                      </div>
                    </ng-container>
                  </span>
                  <!-- <span> <i class="pickLink icomoon icon-broken-link"></i></span> -->
                </li>


              </ul>
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="'wsjFeed'">
            <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">
              <ul #listEl tabindex="0" class="locked rssfeedul" #listData2>

                <li (click)="openPreview(item)" class="headline" [title]="item.headline">
                  <div class="relhidden">
                    <div class="listCell" [innerHTML]="item.headline"></div>
                  </div>
                </li>

                <li (click)="openPreview(item)" class="agency">
                  <div class="relhidden">
                    <div class="listCell">{{getNewTypeDateYear(item.issueDate)}}</div>
                  </div>
                </li>

                <li (click)="openPreview(item)" class="section" [title]="item.section">
                  <div class="relhidden">
                    <div class="listCell">{{item.section}}</div>
                  </div>
                </li>

                <li (click)="openPreview(item)" class="status" [title]="item.status">
                  <div class="relhidden">
                    <div class="listCell">{{item.status}}</div>
                  </div>
                </li>

                <li (click)="openPreview(item)" class="receivedAt">
                  <div class="relhidden">
                    <div class="listCell">{{getNewTypeDate(item.timestamp)}}</div>
                  </div>
                </li>

                <li class="pickUp">
                  <span class="pickStory icon-pickup" (click)="openStoryEdit(item)">
                    <div class="arrow_box single">Pick as Story</div>
                  </span>
                  <span [class]="(checkIfOnePublished(item) ? 'pickLink green icon-link' : 'pickLink icon-link')"
                    *ngIf="item.wirePublishedStories && item.wirePublishedStories.length > 0">
                    <!-- {{item ? item.agency : 'temporary'}} -->
                    <ng-container *ngIf="item.wirePublishedStories && item.wirePublishedStories.length > 1">
                      <div class="arrow_box multiple">
                        <ng-container *ngFor="let pickedStory of item.wirePublishedStories">
                          <ng-container *ngIf="pickedStory">
                            <ul>
                              <li (click)="open_new(pickedStory.id)" *ngIf="pickedStory.domainId == domain">
                                <div
                                  [class]="((pickedStory.metadata && pickedStory.metadata.status
                                  && pickedStory.metadata.status === 'PUBLISHED') ? 'storyline published' : 'storyline')">
                                  {{pickedStory.title ? pickedStory.title : ''}}</div>
                                <div class="writername">
                                  {{(pickedStory.metadata != null && pickedStory.metadata.authors != null
                                    && pickedStory.metadata.authors.length > 0) ? pickedStory.metadata.authors[0] : '-'}}
                                </div>
                              </li>
                            </ul>
                          </ng-container>
                        </ng-container>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="item.wirePublishedStories && item.wirePublishedStories.length === 1">
                      <div class="arrow_box single" *ngIf="item.wirePublishedStories[0].domainId == domain">
                        {{item.wirePublishedStories[0].title ? item.wirePublishedStories[0].title : ''}}
                      </div>
                    </ng-container>
                  </span>
                  <!-- <span> <i class="pickLink icomoon icon-broken-link"></i></span> -->
                </li>


              </ul>
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="'competitionFeed'">
            <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">
              <ul #listEl tabindex="0" class="locked rssfeedul" #listData2>

                <li (click)="openPreview(item)" class="headline" [title]="item.headline">
                  <div class="relhidden">
                    <div class="listCell">{{item.headline}}</div>
                  </div>
                </li>

                <li (click)="openPreview(item)" class="agency" [title]="item.agency">
                  <div class="relhidden">
                    <div class="listCell">{{item.agency}}</div>
                  </div>
                </li>

                <li (click)="openPreview(item)" class="receivedAt">
                  <div class="relhidden">
                    <div class="listCell">{{getNewTypeDate(item.firstPublishedTimestamp)}}</div>
                  </div>
                </li>

                <li class="pickUp"><span class="pickLink icon-link" (click)="openUrl(item)"></span>

              </ul>
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="'photogalleryFeed'">
            <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">
              <ul #listEl tabindex="0" class="locked rssfeedul" #listData2>

                <li (click)="openPhotoGalleryPreview(item)" class="headline" [title]="item.headline">
                  <div class="relhidden">
                    <div class="listCell">{{item.mobileHeadline}}</div>
                  </div>
                </li>

                <li (click)="openPhotoGalleryPreview(item)" class="photodomainId" >
                  <div class="relhidden">
                    <div class="listCell">{{getDomainName(item)}}</div>
                  </div>
                </li>

                <li (click)="openPhotoGalleryPreview(item)" class="publishDate">
                  <div class="relhidden">
                    <div class="listCell">{{getNewTypeDate(item.lastPublishedDate)}}</div>
                  </div>
                </li>

                <li  *ngIf="isVideoWebStoryEnabled" class="url">
                  <div class="relhidden">
                    <div class="listCell">{{item.aiVideoStatus? item.aiVideoStatus: '-'}}</div>
                  </div>
                </li>

                <!-- <li class="pickUp"><span class="pickLink icon-link" (click)="openUrl(item)"></span> -->
                  <li class="pickUp" style="padding-left: 15px;">
                    <span class="pickStory icon-pickup" (click)="openPickPhotoStory(item)">
                      <div class="arrow_box single">Pick as Story</div>
                    </span>
                    <span [class]="(checkIfOnePublished(item) ? 'pickLink green icon-link' : 'pickLink icon-link')"
                      *ngIf="item.wirePublishedStories && item.wirePublishedStories.length > 0 && checkDomain(item)">
                      <!-- {{item ? item.agency : 'temporary'}} -->

                    </span>
                    <!-- <span> <i class="pickLink icomoon icon-broken-link"></i></span> -->
                  </li>
                  <li *ngIf="isVideoWebStoryEnabled" class="pickUp">
                    <i class="fa fa-download" [ngClass]="{'disabled-icon': item.aiVideoStatus !=='PROCESSED'}"  aria-hidden="true" *ngIf="item.aiVideoUrl" (click)="downloadVideo(item)"></i>
                    <i class="fa fa-video-camera" aria-hidden="true" (click)="openVideoCovertorPopupFun(item,'photo-story')" *ngIf="!item.aiVideoUrl"></i>
                    <i class="icon-view-image" [ngClass]="{'disabled-icon': item.aiVideoStatus !=='PROCESSED'}" aria-hidden="true" (click)="openPreviewVideo(item)" *ngIf="item.aiVideoUrl"></i>
                    <i class="fa fa-share" [ngClass]="{'disabled-icon': item.aiVideoStatus !=='PROCESSED'}" aria-hidden="true" (click)="routeToVideoCms(item)"  *ngIf="item.aiVideoUrl"></i>
                  </li>
              </ul>
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="'webStoryFeed'">
            <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">
              <ul #listEl tabindex="0" class="locked rssfeedul" #listData2>

                <li class="headline-web" [title]="item.headline">
                  <div class="relhidden">
                    <div class="listCell">{{item.mobileHeadline}}</div>
                  </div>
                </li>

                <li  class="webdomainId" >
                  <div class="relhidden">
                    <div class="listCell">{{getDomainName(item)}}</div>
                  </div>
                </li>

                <li class="publishDate">
                  <div class="relhidden">
                    <div class="listCell">{{getNewTypeDate(item.lastPublishedDate)}}</div>
                  </div>
                </li>

                <li class="url">
                  <div class="relhidden">
                    <div class="listCell"><a href="{{item.metadata.canonicalUrl}}" target="_blank" class="link">Link</a></div>
                  </div>
                </li>

                <li class="url">
                  <div class="relhidden">
                    <div class="listCell">{{item.aiVideoStatus? item.aiVideoStatus: '-'}}</div>
                  </div>
                </li>
                
                  <li class="pickUp">
                    <i class="fa fa-download" [ngClass]="{'disabled-icon': item.aiVideoStatus !=='PROCESSED'}"  aria-hidden="true" *ngIf="item.aiVideoUrl" (click)="downloadVideo(item)"></i>
                    <i class="fa fa-video-camera" aria-hidden="true" (click)="openVideoCovertorPopupFun(item,'web-story')" *ngIf="!item.aiVideoUrl"></i>
                    <i class="icon-view-image" [ngClass]="{'disabled-icon': item.aiVideoStatus !=='PROCESSED'}" aria-hidden="true" (click)="openPreviewVideo(item)" *ngIf="item.aiVideoUrl"></i>
                    <i class="fa fa-share" [ngClass]="{'disabled-icon': item.aiVideoStatus !=='PROCESSED'}" aria-hidden="true" (click)="routeToVideoCms(item)"  *ngIf="item.aiVideoUrl"></i>
                  </li>
              </ul>
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="'webstoryFeed'">
            <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">
              <ul #listEl tabindex="0" class="locked rssfeedul" #listData2>

                <li (click)="openWebstoryPreview(item)" class="headline" [title]="item.headline">
                  <div class="relhidden">
                    <div class="listCell">{{item.mobileHeadline}}</div>
                  </div>
                </li>

                <li (click)="openWebstoryPreview(item)" class="domainId" >
                  <div class="relhidden">
                    <div class="listCell">{{getDomainName(item)}}</div>
                  </div>
                </li>

                <li (click)="openWebstoryPreview(item)" class="publishDate">
                  <div class="relhidden">
                    <div class="listCell">{{getNewTypeDate(item.lastPublishedDate)}}</div>
                  </div>
                </li>


                <!-- <li class="pickUp"><span class="pickLink icon-link" (click)="openUrl(item)"></span> -->
                  <li class="pickUp">
                    <span class="pickStory icon-pickup" (click)="openPickWebStory(item,true)">
                      <div class="arrow_box single">Pick as Web Story</div>
                    </span>
                    <span [class]="(checkIfOnePublished(item) ? 'pickLink green icon-link' : 'pickLink icon-link')"
                      *ngIf="item.wirePublishedStories && item.wirePublishedStories.length > 0 && checkDomain(item)">
                      <!-- {{item ? item.agency : 'temporary'}} -->

                    </span>
                    <!-- <span> <i class="pickLink icomoon icon-broken-link"></i></span> -->
                  </li>
              </ul>
            </ng-container>
          </ng-container>

          <ng-container *ngSwitchCase="'storyFeed'" >
            <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">
              <ul #listEl tabindex="0" class="locked rssfeedul" #listData2>

                <li (click)="openStoryFeedPreview(item)" class="headline" [title]="item.headline">
                  <div class="relhidden">
                    <div class="listCell">{{item.mobileHeadline}}</div>
                  </div>
                </li>

                <li (click)="openStoryFeedPreview(item)" class="domainId" >
                  <div class="relhidden">
                    <div class="listCell">{{getDomainName(item)}}</div>
                  </div>
                </li>

                <li (click)="openStoryFeedPreview(item)" class="section">
                  <div class="relhidden">
                    <div class="listCell">{{item.metadata.section}}</div>
                  </div>
                </li>

                <li (click)="openStoryFeedPreview(item)" class="publishDate">
                  <div class="relhidden">
                    <div class="listCell">{{getNewTypeDate(item.lastPublishedDate)}}</div>
                  </div>
                </li>


                <!-- <li class="pickUp"><span class="pickLink icon-link" (click)="openUrl(item)"></span> -->
                  <li class="pickUp">
                    <span class="pickStory icon-pickup" (click)="openPickPhotoStory(item)">
                      <div class="arrow_box single">Pick as Story</div>
                    </span>
                    <span [class]="(checkIfOnePublished(item) ? 'pickLink green icon-link' : 'pickLink icon-link')"
                      *ngIf="item.wirePublishedStories && item.wirePublishedStories.length > 0 && checkDomain(item)">
                      <!-- {{item ? item.agency : 'temporary'}} -->

                    </span>
                    
                    <!-- <span> <i class="pickLink icomoon icon-broken-link"></i></span> -->
                  </li>
              </ul>
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="'LHphotogalleryFeed'">
            <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">
              <ul #listEl tabindex="0" class="locked rssfeedul" #listData2>

                <li (click)="openLHPhotoGalleryPreview(item)" class="headline" [title]="item.headline">
                  <div class="relhidden">
                    <div class="listCell">{{item.headline}}</div>
                  </div>
                </li>

                <li (click)="openLHPhotoGalleryPreview(item)" class="domainId" >
                  <div class="relhidden">
                    <div class="listCell">{{item.domainName}}</div>
                  </div>
                </li>

                <li (click)="openLHPhotoGalleryPreview(item)" class="publishDate">
                  <div class="relhidden">
                    <div class="listCell">{{getNewTypeDate(item.lastPublishedDate)}}</div>
                  </div>
                </li>


                <!-- <li class="pickUp"><span class="pickLink icon-link" (click)="openUrl(item)"></span> -->
                  <li class="pickUp">
                    <span class="pickStory icon-pickup" (click)="openPickPhotoStory(item)">
                      <div class="arrow_box single">Pick as Story</div>
                    </span>
                    <span [class]="(checkIfOnePublished(item) ? 'pickLink green icon-link' : 'pickLink icon-link')"
                      *ngIf="item.wirePublishedStories && item.wirePublishedStories.length > 0 && checkDomain(item)">
                      <!-- {{item ? item.agency : 'temporary'}} -->

                    </span>
                    <!-- <span> <i class="pickLink icomoon icon-broken-link"></i></span> -->
                  </li>
              </ul>
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="'AIgalleryFeed'">
            <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">
              <ul #listEl tabindex="0" class="locked rssfeedul" #listData2>

                <li (click)="openAIGalleryPreview(item)" class="headline" [title]="item.headline">
                  <div class="relhidden">
                    <div class="listCell">{{item.headline}}</div>
                  </div>
                </li>


                <li (click)="openAIGalleryPreview(item)" class="timestamp">
                  <div class="relhidden">
                    <div class="listCell">{{getNewTypeDate(item.timestamp)}}</div>
                  </div>
                </li>


                <!-- <li class="pickUp"><span class="pickLink icon-link" (click)="openUrl(item)"></span> -->
                  <li class="pickUp">
                    <span class="pickStory icon-pickup" (click)="openAIGalleryPreview(item)">
                      <div class="arrow_box single">Pick as Story</div>
                    </span>
                    <span *ngIf="item.isWebStory && aiWebStory" class="pickStory icon-pickup" (click)="openAIGalleryPreview(item)">
                      <div class="arrow_box single">Pick as a Web-Story</div>
                    </span>
                    <span [class]="(checkIfOnePublished(item) ? 'pickLink green icon-link' : 'pickLink icon-link')"
                      *ngIf="item.wirePublishedStories && item.wirePublishedStories.length > 0 && checkDomain(item)">
                      <!-- {{item ? item.agency : 'temporary'}} -->

                    </span>
                    <!-- <span> <i class="pickLink icomoon icon-broken-link"></i></span> -->
                  </li>
              </ul>
            </ng-container>
          </ng-container>

          <ng-container *ngSwitchCase="'affiliateFeed'">
            <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">
              <ul #listEl tabindex="0" class="locked rssfeedul" #listData2>

                <li (click)="openPreview(item)" id="headlineColumn" class="headline" [title]="item.headline">
                  <div class="relhidden">
                    <div class="listCell">{{item.headline}}</div>
                  </div>
                </li>

                <li (click)="openPreview(item)" id="agencyColumnFeedList" class="agency" [title]="item.agency">
                  <div class="relhidden">
                    <div class="listCell">{{item.agency}}</div>
                  </div>
                </li>

                <li (click)="openPreview(item)" id="sectionColumnFeedList" class="section" [title]="item.section">
                  <div class="relhidden">
                    <div class="listCell">{{item.section}}</div>
                  </div>
                </li>

                <li (click)="openPreview(item)" id="receivedAtList" class="receivedAt">
                  <div class="relhidden">
                    <div class="listCell">{{getNewTypeDate(item.timestamp)}}</div>
                  </div>
                </li>

                <li class="pickUp">
                  <span class="pickStory icon-pickup" (click)="openStoryEdit(item)">
                    <div id="pickUpList" class="arrow_box single">Pick as Story</div>
                  </span>
                  <span [class]="(checkIfOnePublished(item) ? 'pickLink green icon-link' : 'pickLink icon-link')"
                    *ngIf="item.wirePublishedStories && item.wirePublishedStories.length > 0 && checkDomain(item)">
                    <!-- {{item ? item.agency : 'temporary'}} -->
                    <ng-container *ngIf="item.wirePublishedStories && item.wirePublishedStories.length > 1">
                      <div class="arrow_box multiple">
                        <ng-container *ngFor="let pickedStory of item.wirePublishedStories">
                          <ng-container *ngIf="pickedStory">
                            <ul>
                              <li (click)="open_new(pickedStory.id)" *ngIf="pickedStory.domainId == domain">
                                <div
                                  [class]="((pickedStory.metadata && pickedStory.metadata.status
                                                        && pickedStory.metadata.status === 'PUBLISHED') ? 'storyline published' : 'storyline')">
                                  {{pickedStory.title ? pickedStory.title : ''}}</div>
                                <div class="writername">
                                  {{(pickedStory.metadata != null && pickedStory.metadata.authors != null
                                  && pickedStory.metadata.authors.length > 0) ? pickedStory.metadata.authors[0] : '-'}}
                                </div>
                              </li>
                            </ul>
                          </ng-container>
                        </ng-container>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="item.wirePublishedStories && item.wirePublishedStories.length === 1">
                      <div class="arrow_box single" *ngIf="item.wirePublishedStories[0].domainId == domain">
                        {{item.wirePublishedStories[0].title ? item.wirePublishedStories[0].title : ''}}
                      </div>
                    </ng-container>
                  </span>
                 
                  <!-- <span> <i class="pickLink icomoon icon-broken-link"></i></span> -->
                </li>

              </ul>
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="'translationFeedHT'">
            <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">
              <ul #listEl tabindex="0" class="locked rssfeedul" #listData2>

                <li (click)="openTranslationPreview(item)" class="headline" [title]="item.headline">
                  <div class="relhidden">
                    <div class="listCell">{{item.mobileHeadline}}</div>
                  </div>
                </li>

                <li (click)="openTranslationPreview(item)" class="domainId" >
                  <div class="relhidden">
                    <div class="listCell">{{item.metadata.section}}</div>
                  </div>
                </li>

                <li (click)="openTranslationPreview(item)" class="publishedDate">
                  <div class="relhidden">
                    <div class="listCell">{{getNewTypeDate(item.lastPublishedDate)}}</div>
                  </div>
                </li>

                <!-- <li class="pickUp"><span class="pickLink icon-link" (click)="openUrl(item)"></span> -->
              </ul>
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="'translationFeedLM'">
            <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">
              <ul #listEl tabindex="0" class="locked rssfeedul" #listData2>

                <li (click)="openTranslationPreview(item)" class="headline" [title]="item.headline">
                  <div class="relhidden">
                    <div class="listCell">{{item.mobileHeadline}}</div>
                  </div>
                </li>

                <li (click)="openTranslationPreview(item)" class="domainId" >
                  <div class="relhidden">
                    <div class="listCell">{{item.metadata.section}}</div>
                  </div>
                </li>

                <li (click)="openTranslationPreview(item)" class="publishedDate">
                  <div class="relhidden">
                    <div class="listCell">{{getNewTypeDate(item.firstPublishedDate)}}</div>
                  </div>
                </li>

                <!-- <li class="pickUp"><span class="pickLink icon-link" (click)="openUrl(item)"></span> -->
              </ul>
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="'translationFeedBangla'">
            <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">
              <ul #listEl tabindex="0" class="locked rssfeedul" #listData2>

                <li (click)="openTranslationPreview(item)" class="headline" [title]="item.headline">
                  <div class="relhidden">
                    <div class="listCell">{{item.urlHeadline}}</div>
                  </div>
                </li>

                <li (click)="openTranslationPreview(item)" class="domainId" >
                  <div class="relhidden">
                    <div class="listCell">{{item.metadata.section}}</div>
                  </div>
                </li>

                <li (click)="openTranslationPreview(item)" class="publishedDate">
                  <div class="relhidden">
                    <div class="listCell">{{getNewTypeDate(item.firstPublishedDate)}}</div>
                  </div>
                </li>

                <!-- <li class="pickUp"><span class="pickLink icon-link" (click)="openUrl(item)"></span> -->
              </ul>
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="'competetionData'">
            <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">
              <ul #listEl tabindex="0" class="locked rssfeedul" #listData2>

                <li (click)="openPreview(item)" class="headline" [title]="item.headline">
                  <div class="relhidden">
                    <div class="listCell">{{item.heading}}</div>
                  </div>
                </li>

                <li (click)="openPreview(item)" class="news_category" >
                  <div class="relhidden">
                    <div class="listCell">{{item.news_category}}</div>
                  </div>
                </li>
                <li (click)="openPreview(item)" class="news_category" >
                  <div class="relhidden">
                    <div class="listCell">{{ extractDomain(item.url) }}</div>
                  </div>
                </li>
                <li class="pickUp pickNew"><span class="pickLink icon-link" (click)="openUrlforData(item.url)"></span>

                <li (click)="openPreview(item)" class="publishedDate">
                  <div class="relhidden">
                    <div class="listCell">{{getNewTypeDate(item.publish_time)}}</div>
                  </div>
                </li>

                <!-- <li class="pickUp"><span class="pickLink icon-link" (click)="openUrl(item)"></span> -->
              </ul>
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="'translationFeedTamil'">
            <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">
              <ul #listEl tabindex="0" class="locked rssfeedul" #listData2>

                <li (click)="openTranslationPreview(item)" class="headline" [title]="item.headline">
                  <div class="relhidden">
                    <div class="listCell">{{item.urlHeadline}}</div>
                  </div>
                </li>

                <li (click)="openTranslationPreview(item)" class="domainId" >
                  <div class="relhidden">
                    <div class="listCell">{{item.metadata.section}}</div>
                  </div>
                </li>

                <li (click)="openTranslationPreview(item)" class="publishedDate">
                  <div class="relhidden">
                    <div class="listCell">{{getNewTypeDate(item.firstPublishedDate)}}</div>
                  </div>
                </li>

                <!-- <li class="pickUp"><span class="pickLink icon-link" (click)="openUrl(item)"></span> -->
              </ul>
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="'translationFeedTelegu'">
            <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">
              <ul #listEl tabindex="0" class="locked rssfeedul" #listData2>

                <li (click)="openTranslationPreview(item)" class="headline" [title]="item.headline">
                  <div class="relhidden">
                    <div class="listCell">{{item.urlHeadline}}</div>
                  </div>
                </li>

                <li (click)="openTranslationPreview(item)" class="domainId" >
                  <div class="relhidden">
                    <div class="listCell">{{item.metadata.section}}</div>
                  </div>
                </li>

                <li (click)="openTranslationPreview(item)" class="publishedDate">
                  <div class="relhidden">
                    <div class="listCell">{{getNewTypeDate(item.firstPublishedDate)}}</div>
                  </div>
                </li>

                <!-- <li class="pickUp"><span class="pickLink icon-link" (click)="openUrl(item)"></span> -->
              </ul>
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="'translationFeedMarathi'">
            <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">
              <ul #listEl tabindex="0" class="locked rssfeedul" #listData2>

                <li (click)="openTranslationPreview(item)" class="headline" [title]="item.headline">
                  <div class="relhidden">
                    <div class="listCell">{{item.urlHeadline}}</div>
                  </div>
                </li>

                <li (click)="openTranslationPreview(item)" class="domainId" >
                  <div class="relhidden">
                    <div class="listCell">{{item.metadata.section}}</div>
                  </div>
                </li>

                <li (click)="openTranslationPreview(item)" class="publishedDate">
                  <div class="relhidden">
                    <div class="listCell">{{getNewTypeDate(item.firstPublishedDate)}}</div>
                  </div>
                </li>

                <!-- <li class="pickUp"><span class="pickLink icon-link" (click)="openUrl(item)"></span> -->
              </ul>
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="'translationFeedKannada'">
            <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">
              <ul #listEl tabindex="0" class="locked rssfeedul" #listData2>

                <li (click)="openTranslationPreview(item)" class="headline" [title]="item.headline">
                  <div class="relhidden">
                    <div class="listCell">{{item.urlHeadline}}</div>
                  </div>
                </li>

                <li (click)="openTranslationPreview(item)" class="domainId" >
                  <div class="relhidden">
                    <div class="listCell">{{item.metadata.section}}</div>
                  </div>
                </li>

                <li (click)="openTranslationPreview(item)" class="publishedDate">
                  <div class="relhidden">
                    <div class="listCell">{{getNewTypeDate(item.firstPublishedDate)}}</div>
                  </div>
                </li>

                <!-- <li class="pickUp"><span class="pickLink icon-link" (click)="openUrl(item)"></span> -->
              </ul>
            </ng-container>
          </ng-container>
          </ng-container>

      </ng-container>
    </ng-template>
  </div>
  </div>






  <div class="footerPagination">
    <div class="pagination" *ngIf="totalRecords > 50">Page
      <ul>
        <ng-container *ngIf="7 > pages">
          <ng-container *ngFor="let j of arrayOne(pages); let i = index">
            <!-- <ng-container *ngIf="i >= (pageNum - 3) && (pageNum + 3) > i && pages > (i+1)"> -->
            <li [class]="pageNum == i ? 'active' : ''" (click)="onPageNumberChange(i)">{{(i + 1)}}</li>
            <!-- </ng-container> -->
          </ng-container>
        </ng-container>
        <ng-container *ngIf="pages > 6">
          <ng-container *ngFor="let j of arrayOne(pages); let i = index">
            <ng-container *ngIf="i >= (pageNum - 3) && (pageNum + 3) > i && pages > (i+1)">
              <li [class]="pageNum == i ? 'active' : ''" (click)="onPageNumberChange(i)">{{(i + 1)}}</li>
            </ng-container>
          </ng-container>
          <li>..</li>
          <li [class]="pageNum == (pages-1) ? 'active' : ''" (click)="onPageNumberChange(pages - 1)">{{(pages)}}</li>
        </ng-container>
      </ul>
    </div>

    <ng-container *ngIf="totalRecords < 50;then displayPaging else showPaging"></ng-container>
    <ng-template #showPaging>
      <div class="recordList">Showing
        <select name="recordList" class="select-wrapper" [(ngModel)]="pageSize"
          (ngModelChange)="onPageSizeChange($event)">
          <option *ngFor="let c of pageSizeArray" [ngValue]="c"> {{c}} </option>
        </select>results of {{totalRecords}}
      </div>
    </ng-template>
    <ng-template #displayPaging>
      <div id="dropDownRecordListInPagination" class="recordList borderNone">
        Showing {{totalRecords}} results</div>
    </ng-template>
  </div>
</div>

<ng-container
  *ngIf="pageId === 'competetionData' && openCompetetionPreview && wirePreviewStory && wirePreviewStory !== null">
  <div class="lightBox wirePreview" style="display:block;">
    <div class="headerLight">
      <div class="close fl spImg" (click)="closePreview()"></div>
    </div>
    <div class="lightContent" *ngIf="wirePreviewStory && wirePreviewStory !== null"
      [ngClass]="{'compare lft': compareStory}">
      <h2>{{wirePreviewStory.heading}}</h2>
      <ng-container>
        <span class="sectionName">{{wirePreviewStory.news_category}} </span>
      </ng-container>
      <ng-container>
        <span class="receivedDate">
          | Publish Date : {{wirePreviewStory.publish_time ? getNewTypeDate(wirePreviewStory.publish_time) : ''}}
        </span>
      </ng-container>
      <ng-container>
        <div class="feedcontent">
         KeyWords : {{wirePreviewStory.keywords}}
        </div>
      </ng-container>
      <ng-container>
        <div class="feedcontent">
          <a [href]="wirePreviewStory.url"
            target="_blank">{{wirePreviewStory.url}}</a>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>


<ng-container *ngIf="pageId !== 'competetionData' && openWirePreview && wirePreviewStory && wirePreviewStory !== null">
  <div class="lightBox wirePreview" style="display:block;">
    <div class="headerLight">
      <div class="close fl spImg" (click)="closePreview()"></div>
      <div class="rightBlock" *ngIf="pageId !== 'competitionFeed'">
        <ul>
          <li *ngIf="!accessDenied">
            <button type="button" name="pickedtimes" class="createCard"
              (click)="updateCopyCounter(wirePreviewStory)">Copied
              for Publish</button>
            <span class="usercount spImg">{{wirePreviewStory.copyCounter}}</span>
          </li>
          <li *ngIf="!accessDenied">
            <button type="button" name="pickedstory" class="createStory" (click)="openStoryEdit(wirePreviewStory)">Pick
              as a Story</button>
            <span class="usercount spImg">{{wirePreviewStory.wirePublishedStories ?
              wirePreviewStory.wirePublishedStories.length : 0}}</span>
            <div class="pickstorywriter"
              *ngIf="wirePreviewStory.wirePublishedStories && wirePreviewStory.wirePublishedStories.length > 0">
              <ul>
                <ng-container *ngFor="let storyItem of wirePreviewStory.wirePublishedStories">
                  <li (click)="open_new(storyItem.id)">
                    <div class="writername">{{storyItem.metadata ? (storyItem.metadata.authors &&
                      storyItem.metadata.authors.length > 0 ?
                      storyItem.metadata.authors[0] : (storyItem.title ? storyItem.title : '-')) : '-'}}</div>
                  </li>
                </ng-container>
              </ul>
            </div>
          </li>
        </ul>
      </div>

    </div>
    <div class="lightContent" *ngIf="wirePreviewStory && wirePreviewStory !== null"
      [ngClass]="{'compare lft': compareStory}">
      <h2>{{wirePreviewStory.headline}}</h2>
      <h4>{{wirePreviewStory.story[0].summary}}</h4>
      <div class="update">
        <span class="agencyName">{{wirePreviewStory.agency}}</span>
        <ng-container *ngIf="wirePreviewStory.agency !== 'POPPER'">
          <span class="sectionName">{{wirePreviewStory.section}}</span>
        </ng-container>
        <ng-container *ngIf="wirePreviewStory.agency === 'POPPER'">
          <span class="sectionName">{{
            (wirePreviewStory.story[0] && wirePreviewStory.story[0]['metadata'] && wirePreviewStory.story[0]['metadata']['section'])
            ? wirePreviewStory.story[0]['metadata']['section'] : ''}}</span>
        </ng-container>
        <ng-container *ngIf="pageId==='currentEconomistFeed' || pageId==='archivedEconomistFeed' || pageId==='printEconomistFeed' || pageId === 'wsjFeed'">
          <span class="receivedDate">
            Issue Date :
            {{wirePreviewStory.issueDate ? getNewTypeDate(wirePreviewStory.issueDate) : ''}}
          </span>
        </ng-container>
        <ng-container *ngIf="pageId === 'competitionFeed'; then pulseDateTemplate else datetemplate"></ng-container>
        <ng-template #datetemplate>
          <span class="receivedDate" *ngIf="pageId==='currentEconomistFeed' || pageId==='archivedEconomistFeed' || pageId==='printEconomistFeed' || pageId === 'wsjFeed' ">
          Recieved Date :
          {{wirePreviewStory.timestamp ? getNewTypeDate(wirePreviewStory.timestamp) : ''}}
        </span>
        </ng-template>
        <ng-template #pulseDateTemplate>
          <span class="receivedDate">{{wirePreviewStory.firstPublishedTimestamp ? getNewTypeDate(wirePreviewStory.firstPublishedTimestamp) : ''}}</span>
        </ng-template>

        <span class="bylines"
          *ngIf="wirePreviewStory && wirePreviewStory.story && (wirePreviewStory.story.length > 0) && (wirePreviewStory.story[0].author) && (wirePreviewStory.story[0].author) !== null">
          {{wirePreviewStory.story[0].author}}
        </span>
      </div>

      <ng-container *ngIf="wirePreviewStory.agency === 'POPPER'">
        <div id="pdfImage3" class="wirecontentimg" *ngIf="(wirePreviewStory.story[0] && wirePreviewStory.story[0]['leadMedia']
        && wirePreviewStory.story[0]['leadMedia']['image'] && wirePreviewStory.story[0]['leadMedia']['image']['images']
        && wirePreviewStory.story[0]['leadMedia']['image']['images']['16X9'])">
          <img [src]="wirePreviewStory.story[0]['leadMedia']['image']['images']['16X9']">
        </div>
        <div class="captionLabel"
          *ngIf="(wirePreviewStory.story[0] && wirePreviewStory.story[0]['leadMedia']
       && wirePreviewStory.story[0]['leadMedia']['image'] && wirePreviewStory.story[0]['leadMedia']['image']['caption'])">
          <label>Caption: {{wirePreviewStory.story[0]['leadMedia']['image']['caption']}}</label>
        </div>
      </ng-container>

      <ng-container *ngIf="wirePreviewStory.agency === 'affiliate'">
        <div id="pdfImage3" class="wirecontentimg" *ngIf="(wirePreviewStory.story[0] && wirePreviewStory.story[0]['leadMedia']
        && wirePreviewStory.story[0]['leadMedia']['image'] && wirePreviewStory.story[0]['leadMedia']['image']['images']
        && wirePreviewStory.story[0]['leadMedia']['image']['images']['16X9'])">
          <img [src]="wirePreviewStory.story[0]['leadMedia']['image']['images']['16X9']">
        </div>
        <div class="captionLabel"
          *ngIf="(wirePreviewStory.story[0] && wirePreviewStory.story[0]['leadMedia']
       && wirePreviewStory.story[0]['leadMedia']['image'] && wirePreviewStory.story[0]['leadMedia']['image']['caption'])">
          <label>Caption: {{wirePreviewStory.story[0]['leadMedia']['image']['caption']}}</label>
        </div>
      </ng-container>
      <ng-container
        *ngIf="wirePreviewStory && wirePreviewStory.story[0].listImages && wirePreviewStory.story[0].listImages.length > 0">
        <div id="pdfImage2" class="wirecontentimg"
          *ngIf="wirePreviewStory.story[0].listImages[0].src.includes('pdf');else previewImg">
          <ng2-pdfjs-viewer
            [pdfSrc]="wirePreviewStory && wirePreviewStory.location ? wireImageDisplayUrl + wirePreviewStory.location + '/' + wirePreviewStory.story[0].listImages[0].src : wireImageDisplayUrl + wirePreviewStory.story[0].listImages[0].src "
            (onDocumentLoad)="pdfDocumentLoaded($event)" [print]="false" [find]="false" [download]="false"
            [fullScreen]="true" [openFile]="false">
          </ng2-pdfjs-viewer>
          <div class="captionLabel">
            <label [innerHTML]="'Caption: ' + wirePreviewStory.story[0].listImages[0].caption"></label>
          </div>
        </div>
        <ng-template #previewImg>
          <div id="pdfImage3" class="wirecontentimg">
            <img *ngIf="pageId!=='currentEconomistFeed' && pageId!=='archivedEconomistFeed' && pageId !== 'wsjFeed'"
              [src]="wireImageDisplayUrl + wirePreviewStory.location + '/' + wirePreviewStory.story[0].listImages[0].src"
              [title]="wirePreviewStory.story[0].listImages[0].caption">
              <img *ngIf="pageId==='currentEconomistFeed' || pageId==='archivedEconomistFeed' || pageId === 'wsjFeed'"
              [src]="wireImageDisplayUrl + wirePreviewStory.story[0].listImages[0].src"
              [title]="wirePreviewStory.story[0].listImages[0].caption">
          </div>
          <div class="captionLabel">
            <label [innerHTML]="'Caption: ' + wirePreviewStory.story[0].listImages[0].caption"></label>
          </div>

        </ng-template>
      </ng-container>
      <ng-container *ngIf="pageId === 'competitionFeed'; then pulseTemplate else template"></ng-container>
      <ng-template #template>
        <div class="feedcontent" [innerHTML]="wireContent"></div>
      </ng-template>
      <ng-template #pulseTemplate>
        <div class="feedcontent">
          <a [href]="'http://www.dereferer.org/?'+wirePreviewStory.story[0].content"
            target="_blank">{{wirePreviewStory.story[0].content}}</a>
        </div>
      </ng-template>
      <ng-container
        *ngIf="wirePreviewStory && wirePreviewStory.story[0].images && wirePreviewStory.story[0].images.length > 1">
        <ng-container *ngFor="let image of wirePreviewStory.story[0].images; let i = index">
          <ng-container *ngIf="i > 0">
            <div class="wirecontentimg">
              <ng-container *ngIf="image.includes('pdf')">
                <ng2-pdfjs-viewer
                [pdfSrc]="wirePreviewStory && wirePreviewStory.location ? wireImageDisplayUrl + wirePreviewStory.location + '/' + image : wireImageDisplayUrl +image"
                (onDocumentLoad)="pdfDocumentLoaded($event)" [print]="false" [find]="false" [download]="false"
                [fullScreen]="true" [openFile]="false">
                </ng2-pdfjs-viewer>
              </ng-container>
              <ng-container *ngIf="!image.includes('pdf')">
                <img [src]="wirePreviewStory && wirePreviewStory.location ? wireImageDisplayUrl + wirePreviewStory.location + '/' + image : wireImageDisplayUrl +image ">
              </ng-container>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-container
        *ngIf="wirePreviewStory && wirePreviewStory.story[0].listImages && wirePreviewStory.story[0].listImages.length > 1">
        <ng-container *ngFor="let image of wirePreviewStory.story[0].listImages; let i = index">
          <ng-container *ngIf="i > 0">
            <div class="wirecontentimg">
              <ng-container *ngIf="image.src.includes('pdf')">
                <ng2-pdfjs-viewer
                [pdfSrc]="wirePreviewStory && wirePreviewStory.location ? wireImageDisplayUrl + wirePreviewStory.location + '/' + image.src : wireImageDisplayUrl +image.src "
                (onDocumentLoad)="pdfDocumentLoaded($event)" [print]="false" [find]="false" [download]="false"
                [fullScreen]="true" [openFile]="false">
                </ng2-pdfjs-viewer>
              </ng-container>
                <ng-container *ngIf="!image.src.includes('pdf')">
                <img [src]="wirePreviewStory && wirePreviewStory.location ? wireImageDisplayUrl + wirePreviewStory.location + '/' + image.src : wireImageDisplayUrl +image.src " [title]="image.caption">
              </ng-container>
              <div class="captionLabel">
                <label [innerHTML]="'Caption: ' + image.caption"></label>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>

  </div>
</ng-container>

<!-- Twitter Temp View -->

<ng-container  *ngIf="openTwitterWirePreview && wirePreviewStory && wirePreviewStory !== null">
  <div class="lightBox wirePreview" style="display:block;">
    <div class="headerLight">
      <div class="close fl spImg" (click)="closePreview()"></div>
    </div>
    <div #embedEl class="lightContent" *ngIf="wirePreviewStory && wirePreviewStory !== null"
    [ngClass]="{'compare lft': compareStory}">
      <div [innerHtml]="trustedHTML">
      </div>
    </div>
  </div>
</ng-container>

<!-- PhotoGallery Temp View -->
<ng-container *ngIf="openPhotoGalleryView">
  <div class="lightBox wirePreview" style="display:block;">
    <div class="headerLight">
      <div class="close fl spImg" (click)="closePreview()"></div>
      <div class="rightBlock" *ngIf="pageId !== 'competitionFeed'">
        <ul>
          <li *ngIf="!galleryAccessDenied">
            <button type="button" name="pickedstory" class="pickStory" (click)="openPickPhotoStory(photoGalleryData)">Pick as a Story</button>
          </li>
        </ul>
      </div>

    </div>
    <div class="lightContent" *ngIf="photoGalleryData && photoGalleryData !== null"
      [ngClass]="{'compare lft': compareStory}">
      <h2>{{photoGalleryData.headline}}</h2>
      <h5 [innerHTML]="photoGalleryData.summary"></h5>
      <div class="update">
        <span class="agencyName">{{photoGalleryData.metadata.agency}}</span>
        <ng-container *ngIf="photoGalleryData.metadata.agency !== 'POPPER'">
          <span class="sectionName">{{photoGalleryData.metadata.section}}</span>
        </ng-container>
        <ng-container *ngIf="photoGalleryData.metadata.agency === 'POPPER'">
          <span class="sectionName">{{
            (photoGalleryData && photoGalleryData.metadata && photoGalleryData.metadata.section)
            ? photoGalleryData.metadata.section : ''}}</span>
        </ng-container>

        <span class="bylines"
          *ngIf="photoGalleryData && photoGalleryData.metadata && photoGalleryData.metadata.authors.length > 0">
          {{photoGalleryData.metadata.authors[0]}}
        </span>
      </div>
      <ng-container *ngFor="let imageData of photoGalleryData.imageData">
          <div class="wirecontentimg">
              <img [src]="imageData['image']['images']['1600x900'] ? imageData['image']['images']['1600x900'] : imageData['image']['images']['original'] " >
          </div>
          <div class="captionLabel"
          *ngIf="(imageData && imageData['image'] && imageData['image']['caption'])">
          <label>Caption: {{ removeHTML(imageData['image']['caption']) }}</label>
        </div>
      </ng-container>

    <div class="clearBoth"></div>
    </div>

  </div>
</ng-container>

<ng-container *ngIf="openPhotoGalleryView">
  <div class="lightBox wirePreview" style="display:block;">
    <div class="headerLight">
      <div class="close fl spImg" (click)="closePreview()"></div>
      <div class="rightBlock" *ngIf="pageId !== 'competitionFeed'">
        <ul>
          <li *ngIf="!galleryAccessDenied">
            <button type="button" name="pickedstory" class="pickStory" (click)="openPickPhotoStory(photoGalleryData)">Pick as a Story</button>
          </li>
        </ul>
      </div>

    </div>
    <div class="lightContent" *ngIf="photoGalleryData && photoGalleryData !== null"
      [ngClass]="{'compare lft': compareStory}">
      <h2>{{photoGalleryData.headline}}</h2>
      <h5 [innerHTML]="photoGalleryData.summary"></h5>
      <div class="update">
        <span class="agencyName">{{photoGalleryData.metadata.agency}}</span>
        <ng-container *ngIf="photoGalleryData.metadata.agency !== 'POPPER'">
          <span class="sectionName">{{photoGalleryData.metadata.section}}</span>
        </ng-container>
        <ng-container *ngIf="photoGalleryData.metadata.agency === 'POPPER'">
          <span class="sectionName">{{
            (photoGalleryData && photoGalleryData.metadata && photoGalleryData.metadata.section)
            ? photoGalleryData.metadata.section : ''}}</span>
        </ng-container>

        <span class="bylines"
          *ngIf="photoGalleryData && photoGalleryData.metadata && photoGalleryData.metadata.authors.length > 0">
          {{photoGalleryData.metadata.authors[0]}}
        </span>
      </div>
      <ng-container *ngFor="let imageData of photoGalleryData.imageData">
          <div class="wirecontentimg">
              <img [src]="imageData['image']['images']['1600x900'] ? imageData['image']['images']['1600x900'] : imageData['image']['images']['original'] " >
          </div>
          <div class="captionLabel"
          *ngIf="(imageData && imageData['image'] && imageData['image']['caption'])">
          <label>Caption: {{ removeHTML(imageData['image']['caption']) }}</label>
        </div>
      </ng-container>

    <div class="clearBoth"></div>
    </div>

  </div>
</ng-container>
<ng-container *ngIf="openWebstoryView">
  <div class="lightBox wirePreview" style="display:block;">
    <div class="headerLight">
      <div class="close fl spImg" (click)="closePreview()"></div>
      <div class="rightBlock">
        <ul>
          <li>
            <button type="button" name="pickedstory" class="pickStory" (click)="openPickWebStory(webstoryData,true)">Pick as a Web Story</button>
          </li>
        </ul>
      </div>

    </div>
    <div class="lightContent" *ngIf="webstoryData && webstoryData !== null"
      [ngClass]="{'compare lft': compareStory}">
      <h2>{{webstoryData.headline}}</h2>
      <h5 [innerHTML]="webstoryData.summary"></h5>
      <div class="update">
        <span class="agencyName">{{webstoryData.metadata.agency}}</span>
        <ng-container *ngIf="webstoryData.metadata.agency !== 'POPPER'">
          <span class="sectionName">{{webstoryData.metadata.section}}</span>
        </ng-container>
        <ng-container *ngIf="webstoryData.metadata.agency === 'POPPER'">
          <span class="sectionName">{{
            (webstoryData && webstoryData.metadata && webstoryData.metadata.section)
            ? webstoryData.metadata.section : ''}}</span>
        </ng-container>

        <span class="bylines"
          *ngIf="webstoryData && webstoryData.metadata && webstoryData.metadata.authors.length > 0">
          {{webstoryData.metadata.authors[0]}}
        </span>
      </div>
      <ng-container *ngIf="webstoryPreviewUrl">
      <span class="paragraph">
            <div class="feedcontent">
            <iframe [src]="webstoryPreviewUrl"
             width="100%" height="600" frameborder="0"
             sandbox="allow-same-origin allow-scripts allow-popups"></iframe>
            <h5>
              <a href="{{webstoryData['metadata']['canonicalUrl']}}"  
              target="_blank">Link to the original webstory</a>
            </h5>
          </div>
      </span>
    </ng-container>
    <div class="clearBoth"></div>
    </div>

  </div>
</ng-container>
<!-- StoryFeed View -->
<ng-container *ngIf="openStoryFeedView">
  <div class="lightBox wirePreview" style="display:block;">
    <div class="headerLight">
      <div class="close fl spImg" (click)="closePreview()"></div>
      <div class="rightBlock" *ngIf="pageId !== 'competitionFeed'">
        <ul>
          <li *ngIf="!accessDenied">
            <button type="button" name="pickedstory" class="pickStory" (click)="openPickPhotoStory(feedsStoryData)">Pick as a Story</button>
          </li>
        </ul>
      </div>

    </div>
    <div class="lightContent" *ngIf="feedsStoryData && feedsStoryData !== null"
      [ngClass]="{'compare lft': compareStory}">
      <h2>{{feedsStoryData.headline}}</h2>
      <h5 [innerHTML]="feedsStoryData.summary"></h5>
      <div class="update">
        <span class="agencyName">{{feedsStoryData.metadata.agency}}</span>
        <ng-container *ngIf="feedsStoryData.metadata.agency !== 'POPPER'">
          <span class="sectionName">{{feedsStoryData.metadata.section}}</span>
        </ng-container>
        <ng-container *ngIf="feedsStoryData.metadata.agency === 'POPPER'">
          <span class="sectionName">{{
            (feedsStoryData && feedsStoryData.metadata && feedsStoryData.metadata.section)
            ? feedsStoryData.metadata.section : ''}}</span>
        </ng-container>

        <span class="bylines"
          *ngIf="feedsStoryData && feedsStoryData.metadata && feedsStoryData.metadata.authors.length > 0">
          {{feedsStoryData.metadata.authors[0]}}
        </span>
      </div>
      <!-- Lead Media -->
      <ng-container *ngIf="feedsStoryData && feedsStoryData.leadMedia && feedsStoryData.leadMedia.image && feedsStoryData.leadMedia.image['images']">
        <span>Lead Media |</span>
        <div class="wirecontentimg">
          <img [src]="feedsStoryData.leadMedia['image']['images']['1600x900'] ? feedsStoryData.leadMedia['image']['images']['1600x900'] : feedsStoryData.leadMedia['image']['images']['original'] " >
      </div>
      <div class="captionLabel"
          *ngIf="(feedsStoryData.leadMedia['image']['caption'])">
          <label>Caption: {{ removeHTML(feedsStoryData.leadMedia['image']['caption']) }}</label>
        </div>
      </ng-container>
      <!-- Lead Video -->
      <ng-container *ngIf="feedsStoryData && feedsStoryData.leadMedia && feedsStoryData.leadMedia.video && feedsStoryData.leadMedia.video.body">
        <span>Lead Video |</span>
        <div class="respVideo" [innerHtml]="feedsStoryData.leadMedia.video.body | noSanitize"></div>
           
              <div class="captionLabel">
              <label>{{feedsStoryData.leadMedia.video['caption']}}</label>
              </div>
           
      </ng-container>
      <!-- Lead GIF
      <ng-container *ngIf="feedsStoryData && feedsStoryData.leadMediaGif && feedsStoryData.leadMediaGif.image && feedsStoryData.leadMediaGif.image['images']">
        <span>Lead Gif |</span>
        <div class="wirecontentimg">
          <img [src]="feedsStoryData.leadMediaGif['image']['images']['1600x900'] ? feedsStoryData.leadMediaGif['image']['images']['1600x900'] : feedsStoryData.leadMediaGif['image']['images']['original'] " >
      </div>
      </ng-container> -->
      <ng-container *ngFor="let imageData of feedsStoryData.imageData">
         <!-- for image -->
         <div class="image">
          <ng-container *ngIf="imageData && imageData['image'] && imageData['image']['images'] && imageData.type=='image'">
            <div class="wirecontentimg">
                <img [src]="imageData['image']['images']['1600x900'] ? imageData['image']['images']['1600x900'] : imageData['image']['images']['original'] " >
            </div>
            <div class="captionLabel"
            *ngIf="(imageData && imageData['image'] && imageData['image']['caption'])">
            <label>Caption: {{ removeHTML(imageData['image']['caption']) }}</label>
          </div>
        </ng-container>
         </div>
      
      <!-- for pdf  -->
      <div class="pdf">
        <ng-container *ngIf="imageData && imageData['image'] && imageData['image']['images'] && imageData.type=='document'">
          <div class="dataField bdrfill" id="pdfHight">
            <ng2-pdfjs-viewer [pdfSrc]="imageData.image.images.original"
           viewerId="MyID" [zoom]="60" [print]="false" [find]="false" [download]="false" [fullScreen]="false" [openFile]="false" [pagemode]="none">
            </ng2-pdfjs-viewer>
         </div>
        </ng-container>
      </div>
     
 <!-- for paragraph -->
        <span class="paragraph">
          <ng-container *ngIf="imageData && imageData['paragraph'] && imageData['paragraph']['body'] && imageData.type=='paragraph'">
            <div class="feedcontent" [innerHTML]="imageData['paragraph']['body']"></div>
        </ng-container>
        </span>
     
       <!-- for  amazon embeds -->
       <div class="amazonembeds">
        <ng-container *ngIf="imageData && imageData['amazonAds'] && imageData['amazonAds'].length>0 && imageData.type=='embed'">
          <b>{{imageData.embed.title}}</b> <br><br>
           <ng-container *ngFor="let embed of  imageData['amazonAds'];let i =index;">
           
            <div class="wirecontentimg">
              <span>{{embed.key}}</span> : <span>{{embed.value}}</span>
              <span *ngIf="embed.isPresent !=undefined && embed.isPresent==false; else presentBlock">❌</span>
            <ng-template #presentBlock>
              <span>✅</span>
            </ng-template>
            <br><br>
          </div>
           </ng-container>
       </ng-container>
       </div>
      
      <!-- for embed -->
      <div class="embeds">
      <ng-container *ngIf="imageData.embed && imageData.embed.body && imageData.type=='embed'">
        <div class="respVideo" [innerHtml]="imageData.embed.body | noSanitize"></div>
      </ng-container>
    </div>
     <!-- for videos -->
     <div class="videos">
      <ng-container *ngIf="imageData.video && imageData.video.body && imageData.type=='video'">
        <div class="respVideo" [innerHtml]="imageData.video.body | noSanitize"></div>
         
            <div class="captionLabel">
            <label>{{removeHTML(imageData.video['caption'])}}</label>
            </div>
         
  </ng-container>
     </div>
    
      </ng-container>

    <div class="clearBoth"></div>
    </div>

  </div>
</ng-container>
<ng-container *ngIf="openTranslationView">
  <div class="lightBox wirePreview" style="display:block;">
    <div class="headerLight">
      <div class="close fl spImg" (click)="closePreview()"></div>
      <div class="rightBlock" *ngIf="(pageId !== 'competitionFeed')">
        <ul>
          <li>
            <button *ngIf="!accessDenied" type="button" name="pickedstory" class="pickStory" (click)="openPickAsTranslatedStory(pickedData)">Pick as {{translationType}} Story</button>
          </li>
        </ul>
      </div>

    </div>
    <div class="lightContent" *ngIf="storyData && storyData !== null"
      [ngClass]="{'compare lft': compareStory}">
     
      <div class="tabs">
  
        <input id="tab1" type="radio" name="tabsA" checked>
        <label for="tab1" (click)="clickTab('original')">Original</label>
          
        <input id="tab2" type="radio" name="tabsA">
        <label for="tab2" (click)="clickTab('translated')">Translated</label>
          
            
        <section *ngIf="translationType==='original'">
          <h2>{{pickedHeadline}}</h2>
          <h5 [innerHTML]="pickedSummary"></h5>
          <div class="update">
            <span class="agencyName">{{storyData.metadata.agency}}</span>
            <ng-container *ngIf="storyData.metadata.agency !== 'POPPER'">
              <span class="sectionName">{{storyData.metadata.section}}</span>
            </ng-container>
            <ng-container *ngIf="storyData.metadata.agency === 'POPPER'">
              <span class="sectionName">{{
                (storyData && storyData.metadata && storyData.metadata.section)
                ? storyData.metadata.section : ''}}</span>
            </ng-container>
    
            <span class="bylines"
              *ngIf="storyData && storyData.metadata && storyData.metadata.authors.length > 0">
              {{storyData.metadata.authors[0]}}
            </span>
            <div class="wirecontentimg" *ngIf="(storyData && storyData['leadMedia'] && storyData['leadMedia']['image'] && storyData['leadMedia']['image']['caption'])">
              <img [src]="storyData['leadMedia']['image']['images']['original'] " >
            </div>
            <div class="captionLabel"
              *ngIf="(storyData && storyData['leadMedia'] && storyData['leadMedia']['image'] && storyData['leadMedia']['image']['caption'])">
              <label>Lead Media Caption: {{ removeHTML(storyData['leadMedia']['image']['caption']) }}</label>
            </div>
            <ng-container *ngFor="let data of originalData">
              <ng-container *ngIf="data.type === 'paragraph'">
                <div class="feedcontent" [innerHTML]="data.paragraph.body"></div>
              </ng-container>
              <ng-container *ngIf="data.type === 'image'">
                <div class="wirecontentimg" *ngIf="data && data['image'] && data['image']['images']">
                  <img [src]="data['image']['images']['1600x900'] ? data['image']['images']['1600x900'] : data['image']['images']['original'] " >
                </div>
                <div class="captionLabel"
                *ngIf="(data && data['image'] && data['image']['caption'])">
                <label>Caption: {{ removeHTML(data['image']['caption']) }}</label>
              </div>
              </ng-container>
              
          </ng-container>
          </div>
        </section>
          
        <section  *ngIf="translationType==='translated'" >
          <h2>{{translatedHeadline}}</h2>
          <h5 [innerHTML]="translatedSummary"></h5>
          <div class="update">
            <span class="agencyName">{{storyData.metadata.agency}}</span>
            <ng-container *ngIf="storyData.metadata.agency !== 'POPPER'">
              <span class="sectionName">{{storyData.metadata.section}}</span>
            </ng-container>
            <ng-container *ngIf="storyData.metadata.agency === 'POPPER'">
              <span class="sectionName">{{
                (storyData && storyData.metadata && storyData.metadata.section)
                ? storyData.metadata.section : ''}}</span>
            </ng-container>
    
            <span class="bylines"
              *ngIf="storyData && storyData.metadata && storyData.metadata.authors.length > 0">
              {{storyData.metadata.authors[0]}}
            </span>
            <div class="wirecontentimg" *ngIf="(storyData && storyData['leadMedia'] && storyData['leadMedia']['image'] && storyData['leadMedia']['image']['caption'])">
              <img [src]="storyData['leadMedia']['image']['images']['original'] " >
            </div>
            <div class="captionLabel"
              *ngIf="(storyData && storyData['leadMedia'] && storyData['leadMedia']['image'] && storyData['leadMedia']['image']['caption'])">
              <label>Lead Media Caption: {{ removeHTML(storyData['leadMedia']['image']['caption']) }}</label>
            </div>
            <ng-container *ngFor="let data of translatedData">
              <ng-container *ngIf="data.type === 'paragraph'">
                <div class="feedcontent" [innerHTML]="data.paragraph.body"></div>
              </ng-container>
              <ng-container *ngIf="data.type === 'image'">
                <div class="wirecontentimg" *ngIf="data && data['image'] && data['image']['images']">
                  <img [src]="data['image']['images']['1600x900'] ? data['image']['images']['1600x900'] : data['image']['images']['original'] " >
                </div>
                <div class="captionLabel"
                *ngIf="(data && data['image'] && data['image']['caption'])">
                <label>Caption: {{ removeHTML(data['image']['caption']) }}</label>
              </div>
              </ng-container>
              
          </ng-container>
          </div>
         
        </section>
          
      
      </div>
   
     

    <div class="clearBoth"></div>
    </div>

  </div>
</ng-container>

<ng-container *ngIf="openLHPhotoGalleryView">
  <div class="lightBox wirePreview" style="display:block;">
    <div class="headerLight">
      <div class="close fl spImg" (click)="closePreview()"></div>
      <div class="rightBlock" *ngIf="pageId !== 'competitionFeed'">
        <ul>
          <li *ngIf="!galleryAccessDenied">
            <button type="button" name="pickedstory" class="pickStory" (click)="openPickPhotoStory(photoGalleryData)">Pick as a Story</button>
          </li>
        </ul>
      </div>

    </div>
    <div class="lightContent" *ngIf="photoGalleryData && photoGalleryData !== null"
      [ngClass]="{'compare lft': compareStory}">
      <h2>{{photoGalleryData.headline}}</h2>
      <!-- <h2>headline trial Check</h2> -->
      <!-- <h5 [innerHTML]="photoGalleryData.summary"></h5> -->
      <div class="update">
        <span class="agencyName">Last Publish Date - {{getNewTypeDate(photoGalleryData.lastPublishedDate)}}</span>
      </div>
      <ng-container *ngFor="let imageData of photoGalleryData.imageList">
          <div class="wirecontentimg">
              <img [src]="imageData['imr_url']" >
          </div>
          <div class="captionLabel"
          *ngIf="(imageData && imageData['img_description'])">
          <label>Caption: {{ imageData['img_description'] }}</label>
        </div>
      </ng-container>

    <div class="clearBoth"></div>
    </div>

  </div>
</ng-container>

<ng-container *ngIf="openAIGalleryView">
  <div class="lightBox wirePreview" style="display:block;">
    <div class="headerLight">
      <div class="close fl spImg" (click)="closePreview()"></div>
      <div class="rightBlock" *ngIf="pageId !== 'competitionFeed'">
        <ul>
          <li *ngIf="!galleryAccessDenied && aiWebStory">
            <button style="margin-right: 5px;" *ngIf="photoGalleryData.isWebStory" type="button" name="pickedstory" class="pickStory" (click)="openPickWebStory(photoGalleryData)">Pick as a Web Story</button>
          </li>
          <li *ngIf="!galleryAccessDenied">
            <button type="button" name="pickedstory" class="pickStory" (click)="openPickPhotoStory(photoGalleryData,true)">Pick as a Story</button>
          </li>
        </ul>
      </div>

    </div>
    <div class="lightContent" *ngIf="photoGalleryData && photoGalleryData !== null"
      [ngClass]="{'compare lft': compareStory}">
      <h2>{{photoGalleryData.headline}}</h2>
      <h5 [innerHTML]="(photoGalleryData.story[0].summary).substring(0,300)+ ' ....'"></h5>
      <div class="update">
        <span class="agencyName">Timestamp - {{getNewTypeDate(photoGalleryData.timestamp)}}</span>
      </div>
      <ng-container *ngFor="let imageData of photoGalleryData.story[0].listImages; let i = index">
          <div class="wirecontentimg">
            <div *ngIf="imageData.images===null">
              <img [src]="wireImageDisplayUrl + photoGalleryData.location + '/' +imageData['src']" >
              <div class="captionLabel"
              *ngIf="(imageData && imageData['caption'])">
              <label>Caption: {{ imageData['caption'] }}</label>
            </div>
            </div>
            <div  *ngIf="imageData && imageData.images && imageData.images.length>0">
              <owl-carousel-o [options]="customOptions" #owlCarousel>
                  <ng-container *ngFor="let image of imageData.images; let index = index">
                      <ng-template [width]="730" carouselSlide>
                          <div style="margin-right: 10px" class="item">
                              <h4><img style="border-radius: 7px;width:730px;height: 700px;"
                                      [src]="wireImageDisplayUrl + photoGalleryData.location + '/' +image['src']"></h4>
                                      <div class="captionLabel"
                                      *ngIf="(image && image['caption'])">
                                      <label>Credit: {{ image['credit'] }}</label>
                                      <label>Caption: {{ image['caption'] }}</label>
                                    </div>
                          </div>
                          <div class="owl-content" *ngIf="imageData.images.length>1">
                            <p class="owl-para">{{index+1}}  To  {{imageData.images.length}}</p>
                          </div>
                      </ng-template>
                  </ng-container>
              </owl-carousel-o>
          <div class="main-owl-content" *ngIf="imageData.images.length>1">
            <i class='fa fa-chevron-left' (click)="prevSlide(owlCarousel,i+1,imageData)"></i>
          </div>
          <div class="main-owl-content-second" *ngIf="imageData.images.length>1">
            <i class='fa fa-chevron-right' (click)="nextSlide(owlCarousel,i+1,imageData)"></i>
          </div>
        </div>
        </div>
         
      </ng-container>
 
    <div class="clearBoth"></div>
    </div>

  </div>
</ng-container>

<ng-container  *ngIf="openVideoCovertorPopup">
  <div class="lightBox wirePreview" style="display:block;">
    <div class="headerLight">
      <div class="close fl spImg" (click)="closeVideoConvertorPopup()"></div>
    </div>
    <div #embedEl class="lightContent"
    [ngClass]="{'compare lft': compareStory}">
    <div class="feedpopup">
        <div class="select-video">
          <select  class="select-wrapper" name="selectRole" (change)="selectLogo($event.target.value)">
            <option disabled>Select Logo</option>
            <option *ngFor="let logo of logoList" [value]="logo.path">{{logo.name}}</option>
          </select>
          <img src="{{logoUrl}}" width="40px" *ngIf="logoUrl">
        </div>

        <div>
          <select  class="select-wrapper" name="selectRole" (change)="selectAudio($event.target.value)">
            <option disabled>Select Audio</option>
            <option *ngFor="let audio of audioList" [value]="audio.path">{{audio.name}}</option>
          </select>
          <audio controls controlsList="nodownload" style="height: 26px;" *ngIf="audioUrl">
            <source src="{{audioUrl}}" type="audio/mpeg">
          </audio>
        </div>
        <div class="feedform" style="text-align: center;"> <button  class="blue" (click)="convertToVideo()" [disabled]="(logoUrl && audioUrl) ? false: true">Convert to video</button></div>
    </div>
   
    </div>
  </div>
</ng-container>

<ng-container  *ngIf="openVideoPopup">
  <div class="lightBox wirePreview" style="display:block;">
    <div class="headerLight">
      <div class="close fl spImg" (click)="closeVideoPopup()"></div>
    </div>
    <div #embedEl class="lightContent"
    [ngClass]="{'compare lft': compareStory}" style="height: 450px;">
    <ng-container *ngIf="trustedHTML" >
      <video width="100%" height="100%" [src]="trustedHTML" type="video/*" controls>
        Your browser does not support the video tag.
      </video>
    </ng-container>
      <!-- <div [innerHtml]="trustedHTML">
      </div> -->
    </div>
  </div>
</ng-container>
<div class="loaderimage block" *ngIf="showLoader">
  <div class="imagepreloader">
    <!-- <h3>TRANSLATING...</h3> -->
    <div class="a" style="--n: 5;">
      <div class="dot dot1" style="--i: 0;"></div>
      <div class="dot dot2" style="--i: 1;"></div>
      <div class="dot dot3" style="--i: 2;"></div>
      <div class="dot dot4" style="--i: 3;"></div>
    </div>
  </div>
</div>
